/**
 * Singapura 날짜 표기 — 고객 원본 Word 표기 "30 June 2026"(월 전체 이름, 일자 앞 0 없음). 고객 요청 2026-10-15.
 *   대상 마이프리셋: Active-declaration statement / Verification of data / Active-Exempt-unaudited(AGM).
 *   · 화면: provideAgmFill({ formatDate: toLongDate }) → CddVarField 가 세션 형식 대신 이 표기로 보여준다(저장은 ISO 그대로).
 *   · 공용 날짜 유틸(formatDateOnly 등)은 건드리지 않는다 — Singapura 전용.
 *   · 문서: normalize 에서 longDateDeep 으로 바꿔 넘긴다. 백엔드 치환기는 ISO 만 세션 형식으로 바꾸므로 이미 바뀐 글자는 그대로 나간다.
 */
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/** "2026-06-30"(또는 "2026-06-30T…") · "30/06/2026"(등록부 API dd/mm/yyyy) → "30 June 2026". 날짜가 아니면 ''. */
export function toLongDate(v: string): string {
  const s = String(v ?? '').trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/);
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  const [y, mo, d] = iso ? [iso[1], iso[2], iso[3]] : dmy ? [dmy[3], dmy[2], dmy[1]] : ['', '', ''];
  const month = MONTHS[Number(mo) - 1];
  const day = Number(d);
  if (!y || !month || !day || day > 31) return '';
  return `${day} ${month} ${y}`;
}

/** 객체/배열(반복부 item 포함)의 날짜 문자열을 전부 "30 June 2026" 로 바꾼 복사본 — 화면 상태(원본)는 건드리지 않는다. */
export function longDateDeep<T>(node: T): T {
  if (typeof node === 'string') return (toLongDate(node) || node) as any;
  if (Array.isArray(node)) return node.map((v) => longDateDeep(v)) as any;
  if (node && typeof node === 'object' && Object.getPrototypeOf(node) === Object.prototype) {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(node as Record<string, any>)) out[k] = longDateDeep(v);
    return out as any;
  }
  return node;
}
